import { DateTime } from 'luxon';

type RecurrenceCommitmentInfo = {
  periodDescription: string;
  amountPerPeriod: number;
  endDate: string | null;
  autoCharge: boolean;
};

/**
 * A cobrança automática vem marcada por padrão: quem chega nesta tela através de
 * uma cobrança de recorrência já decidiu assinar. Débito fica de fora porque o
 * PagSeguro não tokeniza cartão de débito para cobranças subsequentes.
 */
export const defaultAutoRecurrence = (
  method: 'CREDIT_CARD' | 'DEBIT_CARD',
  recurrence?: RecurrenceCommitmentInfo,
) => method === 'CREDIT_CARD' && !!recurrence && !recurrence.autoCharge;

/** Deixa explícito o que o pagador está autorizando, não só o valor de hoje. */
export const buildRecurrenceCommitment = (
  recurrence: RecurrenceCommitmentInfo,
  formatAmount: (value: number) => string,
) => {
  const base = `Depois, ${formatAmount(recurrence.amountPerPeriod)} por cobrança ${
    recurrence.periodDescription
  } neste cartão`;

  if (!recurrence.endDate) {
    return base;
  }

  return `${base} até ${DateTime.fromISO(recurrence.endDate, { zone: 'utc' }).toFormat(
    'dd/MM/yyyy',
  )}`;
};
